module.exports = ".hotspotTemplate {\n  margin-left: 5px;\n}\n"